module.exports = __webpack_public_path__ + "static/media/Pancakes & Waffles.8358599e.jpg";